import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { MonEtablissementForm } from '@features/compte/mon-etablissement/features/mon-etablissement-detail/models/mon-Etablissement-form';
import { Iban } from '@shared/models/referentiel/ibans';

export const MonEtablissementPageActions = createActionGroup({
  source: 'Mon Etablissement Page',
  events: {
    'Update Form': props<{ form: MonEtablissementForm }>(),
    'Reset Form': props<{ form: MonEtablissementForm }>(),
    'Click Envoyer': props<{ form: MonEtablissementForm }>(),
    'Click Envoyer Success': props<{ form: MonEtablissementForm }>(),
    'Click Envoyer Failure': props<{ errorMessage: string }>(),
    'Update Loading': props<{ isLoading: boolean }>(),
    'Load Ibans': props<{ siret: string }>(),
    'Load Ibans Success': props<{ ibans: Iban[] }>(),
    'Load Ibans Failure': props<{ errorMessage: string }>(),
    'Add Iban': props<{ siret: string; iban: string }>(),
    'Add Iban Success': props<{ iban: Iban }>(),
    'Add Iban Failure': props<{ errorMessage: string }>(),
    'Reset Add Iban State': emptyProps(),
    'No action': emptyProps(),
  },
});
